'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'person-chalkboard';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e53d';
var svgPathData = 'M144 48C144 21.49 165.5 0 192 0C218.5 0 240 21.49 240 48C240 74.51 218.5 96 192 96C165.5 96 144 74.51 144 48zM152 512C138.7 512 128 501.3 128 488V223.6L84.89 299.8C78.37 311.4 63.73 315.4 52.19 308.9C40.65 302.4 36.59 287.7 43.11 276.2L101.7 172.7C117.3 145.1 146.5 128 178.3 128H319.1V48C319.1 21.49 341.5 0 368 0H592C618.5 0 640 21.49 640 48V272C640 298.5 618.5 320 592 320H368C341.5 320 319.1 298.5 319.1 272V224H368V272H592V48H368V128H392C405.3 128 416 138.7 416 152C416 165.3 405.3 176 392 176H256V488C256 501.3 245.3 512 232 512C218.8 512 208 501.3 208 488V352H176V488C176 501.3 165.3 512 152 512H152zM178.3 176C177.5 176 176.8 176 176 176.1V304H208V176H178.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonChalkboard = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;